






















import Vue from 'vue';


export default Vue.extend({
  name: 'ChipMenu',
  props: {
    text: {
      type: String,
      required: true,
    },
    tooltip: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: 'primary',
    },
    dark: {
      type: Boolean,
      default: false,
    },
    chipClass: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openMenu() {
      const menu = this.$refs.menu as any;

      if (menu) {
        menu.isActive = true;
      }
    },
  },
});
